import React, { useState } from 'react'
import { connect } from 'react-redux'
import { actions as unitTestsActions } from '../../../../../../../store/reducers/unit-tests.reducer'
import TestModal from '../TestModal'
import { useAssignmentAccess } from '../../../../../components/access/Access'
import { AssignmentPermissions } from '../../../../../../../constants/assignment-permissions'

const EditFrameworkTestModal = ({
    showEditFrameworkTestModal,
    setShowEditFrameworkTestModal,
    updateFrameworkUnitTest,
    updateFlexibleUnitTest,
}) => {
    const [framework, setFramework] = useState(null)
    const [errorMessage, setErrorMessage] = useState('')

    const flexibleTestFields = {
        name: true,
        framework: true,
        inputs: true,
        testSuite: true,
        cpuTimeLimit: true,
        memoryLimit: true,
        fixtureFiles: true,
    }

    const frameworkTestFields = {
        name: true,
        framework: true,
        testSuite: true,
        mainClassName: true,
        cpuTimeLimit: true,
        memoryLimit: true,
        fixtureFiles: true,
    }

    const hasEditingPermission = useAssignmentAccess([AssignmentPermissions.CAN_EDIT])

    const handleSubmitTest = (token, fields) => {
        setErrorMessage('')
        return (framework === 'flexible' ? updateFlexibleUnitTest : updateFrameworkUnitTest)(
            token, 
            fields, 
            setErrorMessage
        )
    }

    return (
        <TestModal
            showModal={showEditFrameworkTestModal}
            setShowModal={setShowEditFrameworkTestModal}
            submitTest={handleSubmitTest}
            modalTitle={hasEditingPermission ? 'Update framework test' : 'View framework test'}
            submitButtonText='Update'
            fields={framework === 'flexible' ? flexibleTestFields : frameworkTestFields}
            setFramework={setFramework}
            readOnly={!hasEditingPermission}
            errorMessage={errorMessage}
        />
    )
}

const mapState = ({ unitTests }) => {
    return {
        showEditFrameworkTestModal: unitTests.showEditFrameworkTestModal,
    }
}

const mapDispatch = dispatch => {
    return {
        setShowEditFrameworkTestModal: value => {
            dispatch(unitTestsActions.setShowEditFrameworkTestModal(value))
        },
        updateFrameworkUnitTest: (token, fields, setResponseMessage) => {
            return dispatch(unitTestsActions.updateFrameworkUnitTest(token, fields, setResponseMessage))
        },
        updateFlexibleUnitTest: (token, fields, setResponseMessage) => {
            return dispatch(unitTestsActions.updateFlexibleUnitTest(token, fields, setResponseMessage))
        },
    }
}

export default connect(mapState, mapDispatch)(EditFrameworkTestModal)
